import { Box, Container } from "@mui/material";
import Header from "components/header/Header";
import { MediumLargeText } from "components/typography";

export default function OrderOverflown(){
  return(
    <Container sx={{ pl: { lg: 12, md: 12, xs: 12 }, pt: 5 }}>
      <Header header="Bestellung nicht erfolgreich" />
      <Box sx={{display: "flex", flexDirection:"column", pt: 5, gap: 1}}>
        <MediumLargeText>Ein Anbieter der Lose erlaubt nur den Kauf von einer begrenzten Anzahl von Holz, die Sie leider überschritten haben.</MediumLargeText>
      </Box>
    </Container>
  )
}